// This is a workaround to allow fetch requests to throw an error without setting the span to error status.
// NO_ATTRIBUTE prefix is used to exclude the attribute from being added to the span.
export const ALLOWED_TO_ERROR = 'NO_ATTRIBUTE_Allowed_To_Error';
